export default __webpack_public_path__ + "static/media/cog_blue_gradient.a1a3d7bd.svg";